import { call, put, takeLatest } from 'redux-saga/effects';
import { destroyAuth, getAuth } from "services/AuthService";
import { appIsInitialized, INITIALIZE_APP } from "redux/appInit/actions";
import { userSignedInAction } from "redux/sagas/userSignedInSaga";
import axiosInstance from "services/AuthHeader";

export function* initializationSaga() {
  if (getAuth()) {
    try {
      yield call(() => axiosInstance.get("/api/auth/authorized"))
      yield put(userSignedInAction(getAuth()))

    } catch (error) {
      destroyAuth()
    }
  }
  yield put(appIsInitialized())
}

export function* watchForInitializeApp() {
  yield takeLatest(INITIALIZE_APP, initializationSaga);
}